import { useTranslation } from 'react-i18next';
import classes from './Projects.module.scss';
import image from '../../../assets/img/Portfolio/projects.webp';

const Projects = () => {
    const { t } = useTranslation();
    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <div className={classes.content}>
                    <h2 className={`${classes.title} font-48`}>
                        {t('portfolio.projects.title')}
                    </h2>
                    <h4 className={`${classes.subtitle} font-20`}>
                        {t('portfolio.projects.subtitle')}
                    </h4>
                    <div className={`${classes.text} txt-container font-16`}>
                        <p>{t('portfolio.projects.text_01')}</p>
                        <p>{t('portfolio.projects.text_02')}</p>
                        <p>{t('portfolio.projects.text_03')}</p>
                    </div>
                </div>
                <img className={classes.image} src={image} alt='' />
            </div>
        </section>
    );
};

export default Projects;